import {
  DsmRoomReplacementReview,
  DsmRoomReplacementReviewExecution
} from '../models/dsm-room-replacement-review.models';

/**
 * The replacements that still leave something to fix.
 *
 * An execution is recorded for good, so anything gated on the record alone keeps its
 * banner up long after every stranded line has been moved — telling the reader to
 * re-configure options that are no longer highlighted anywhere. A replacement is only
 * worth showing while a line is still sitting in one of the rooms it took away.
 */
export function toActionableReplacements(
  review: DsmRoomReplacementReview | null | undefined
): DsmRoomReplacementReviewExecution[] {
  const strandedLocationIds = new Set((review?.mismatchedLines ?? []).map(line => line.locationId));
  if (!strandedLocationIds.size) return [];

  return (review?.replacements ?? []).filter(replacement =>
    replacement.replacedRooms.some(room => strandedLocationIds.has(room.locationId))
  );
}

/** Product ids of trigger options whose rule has actually run on this deal. */
export function toExecutedTriggerProductIds(review: DsmRoomReplacementReview | null | undefined): ReadonlySet<string> {
  return new Set((review?.replacements ?? []).map(replacement => replacement.triggerProductId));
}
